/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all APIs of the compiler package.
 *
 * <div class="callout is-critical">
 *   <header>Unstable APIs</header>
 *   <p>
 *     All compiler apis are currently considered experimental and private!
 *   </p>
 *   <p>
 *     We expect the APIs in this package to keep on changing. Do not rely on them.
 *   </p>
 * </div>
 */
export { MockResourceLoader } from "./resource_loader_mock";
export { MockSchemaRegistry } from "./schema_registry_mock";
export { MockDirectiveResolver } from "./directive_resolver_mock";
export { MockNgModuleResolver } from "./ng_module_resolver_mock";
export { MockPipeResolver } from "./pipe_resolver_mock";
//# sourceMappingURL=testing.js.map